export default {
  list: {},
  groups: {},
  loaded: false,
  groupsLoaded: false,
};
